export default "__VITE_ASSET__DhZhcUn2__"